import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import addEditModal from './addEditModal.vue';
import detailModal from './detailModal.vue';
import util from '@/utils/util';
var addEditModalCom = util.mountVueComponent(addEditModal);
var detailModalCom = util.mountVueComponent(detailModal);

var ImporterPage = function (_super) {
  __extends(ImporterPage, _super);

  function ImporterPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.total = 0;
    _this.loadingStatus = false;
    _this.statusList = [];
    _this.isEuEnum = [];
    _this.columns = [];
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.rowSelection = {};
    _this.warehouseList = [];
    _this.selectedList = [];
    _this.datetimeDefaultValue = [];
    return _this;
  }

  ImporterPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.time_from = this.$util.formatDateTime(arr[0]);
      this.searchData.time_to = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.time_from = '';
      this.searchData.time_to = '';
    }
  };

  ImporterPage.prototype.getInitSearchData = function () {
    return {
      cv_status: undefined,
      is_eu: undefined,
      warehouse_code: undefined,
      number_type: 'vat_number',
      number: '',
      company_name: '',
      time_type: 'cv_create_time',
      time_from: '',
      time_to: '',
      page_index: 1,
      page_size: 10
    };
  };

  ImporterPage.prototype.onSelectChange = function (selectedRowKeys) {
    this.selectedList = selectedRowKeys;
  };

  ImporterPage.prototype.created = function () {
    this.columns = [{
      title: this.t('进口商编码'),
      dataIndex: 'cv_id',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('公司名称'),
      scopedSlots: {
        customRender: 'companyName'
      }
    }, {
      title: this.t('仓库'),
      dataIndex: 'warehouse',
      scopedSlots: {
        customRender: 'warehouse'
      }
    }, {
      title: this.t('是否英国/欧盟'),
      dataIndex: 'is_eu_text',
      filterEmpty: true
    }, {
      title: this.t('增值税号/豁免号'),
      dataIndex: 'vat',
      scopedSlots: {
        customRender: 'vat'
      }
    }, {
      title: this.t('清关税号'),
      dataIndex: 'eori',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('包装注册号'),
      dataIndex: 'pack_regist_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('状态'),
      scopedSlots: {
        customRender: 'cv_status_text'
      },
      width: 90
    }, {
      title: this.t('时间'),
      scopedSlots: {
        customRender: 'time'
      },
      width: 190
    }, {
      title: this.t('操作'),
      fixed: 'right',
      width: 100,
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.queryImporterList();
    this.queryWarehouseList();
  };

  ImporterPage.prototype.queryImporterList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, _a, list, _b, total;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            this.selectedList.length = 0;
            this.total = null;
            return [4, this.$api.warehouse.queryImporterList(this.searchData)];

          case 1:
            data = _c.sent().data;
            _a = data.list, list = _a === void 0 ? [] : _a, _b = data.total, total = _b === void 0 ? 0 : _b;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  ImporterPage.prototype.delImporter = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.warehouse.delImporter(param)];

          case 1:
            _a.sent();

            this.$message.success(this.t('删除成功'));
            return [2];
        }
      });
    });
  };

  ImporterPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.selectedList = [];
    this.queryImporterList();
  };

  ImporterPage.prototype.handleTabChange = function () {
    this.initPage();
    this.queryImporterList();
  };

  ImporterPage.prototype.handleAdd = function () {
    var _this = this;

    addEditModalCom({
      parent: this,
      propsData: {
        cvId: undefined,
        isCopy: false,
        onSuccess: function onSuccess() {
          _this.queryImporterList();
        }
      }
    });
  };

  ImporterPage.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList()];

          case 1:
            data = _a.sent().data;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  ImporterPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryImporterList();
  };

  ImporterPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.datetimeDefaultValue = [];
    this.$nextTick(function () {
      return _this.queryImporterList();
    });
  };

  ImporterPage.prototype.initPage = function () {
    this.searchData.page_index = 1;
  };

  ImporterPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
              postData["export"] = 1;
              postData.cv_id_list = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData["export"] = 2;
              postData.cv_id_list = this.selectedList;
            }

            return [4, this.$api.warehouse.exportImporter(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  ImporterPage.prototype.cancelBulkImporter = function (id) {
    var _this = this;

    this.$confirm({
      title: this.t('废弃提示'),
      content: this.t('确认废弃该进口商？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          var _a, code, message;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                return [4, this.$api.warehouse.cancelBulkImporter({
                  id_list: [id]
                })];

              case 1:
                _a = _b.sent(), code = _a.code, message = _a.message;

                if (code === 0) {
                  this.$message.success(this.t('操作成功'));
                  this.queryImporterList();
                } else {
                  this.$message.error(message);
                }

                return [2];
            }
          });
        });
      }
    });
  };

  ImporterPage.prototype.handleDeleteBulkImporter = function (id) {
    var _this = this;

    this.$confirm({
      title: this.t('温馨提示'),
      content: this.t('确认删除该进口商？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4, this.delImporter({
                  id_list: [id]
                })];

              case 1:
                _a.sent();

                this.queryImporterList();
                return [2];
            }
          });
        });
      }
    });
  };

  ImporterPage.prototype.handleUpdate = function (record, isCopy) {
    var _this = this;

    addEditModalCom({
      parent: this,
      propsData: {
        warehouseList: this.warehouseList,
        cvId: record.cv_id,
        isCopy: isCopy,
        onSuccess: function onSuccess() {
          _this.queryImporterList();
        }
      }
    });
  };

  ImporterPage.prototype.showDetail = function (record) {
    detailModalCom({
      parent: this,
      propsData: {
        data: record
      }
    });
  };

  __decorate([enumData('ImporterExporter/StatusEnum')], ImporterPage.prototype, "statusList", void 0);

  __decorate([enumData('ImporterExporter/EuTypeEnum')], ImporterPage.prototype, "isEuEnum", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], ImporterPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([userPrefPageSize('commodityImporterList')], ImporterPage.prototype, "getInitSearchData", null);

  __decorate([loading('loadingStatus')], ImporterPage.prototype, "queryImporterList", null);

  ImporterPage = __decorate([Component({
    filters: {
      companyType: function companyType(row, warehouseEnum, t) {
        var warehouse_code = row.warehouse_code,
            is_eu = row.is_eu;
        var isFRVI = warehouse_code === warehouseEnum.importWarehouseCode.FRVI;
        var isUK = warehouse_code === warehouseEnum.importWarehouseCode.UK;
        var isEu = is_eu === warehouseEnum.isEu.y;

        if (is_eu) {
          if (isFRVI) {
            return isEu ? t('欧盟公司') : t('非欧盟公司');
          } else if (isUK) {
            return isEu ? t('英国公司') : t('非英国公司');
          }
        } else {
          return undefined;
        }
      }
    }
  })], ImporterPage);
  return ImporterPage;
}(Vue);

export default ImporterPage;